// extracted by mini-css-extract-plugin
module.exports = {"h1":"Heading_h1__aw9cq","h2":"Heading_h2__3I9bT","h3":"Heading_h3__vYb3x","h4":"Heading_h4__HB4e4","h5":"Heading_h5__6rjSU","h6":"Heading_h6__BYsSf"};